import { render, staticRenderFns } from "./UserProfilesEdit.vue?vue&type=template&id=cf963640&"
import script from "./UserProfilesEdit.vue?vue&type=script&lang=ts&"
export * from "./UserProfilesEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports